import _ from "lodash";

import { ListTagsAndGroupsQuery } from "~frontend/__generated__/graphql";

import { AutocompleteValue } from "../forms/InMemoryCombobox";

export default function formatTagsAndGroups(
  tagsAndGroups: ListTagsAndGroupsQuery
): AutocompleteValue[] {
  return _.sortBy(
    [...tagsAndGroups.listTags, ...tagsAndGroups.listTagGroups],
    "name"
  ).flatMap(tagOrGroup => {
    if (tagOrGroup.__typename === "TagGroup") {
      return [
        {
          id: tagOrGroup.id,
          label: tagOrGroup.name,
          type: "groupHeading",
        },
        ..._.sortBy(tagOrGroup.tags, "name").map(tag => ({
          id: tag.id,
          label: tag.name,
          selectedLabel: `${tagOrGroup.name} > ${tag.name}`,
          type: "groupMember",
          groupId: tagOrGroup.id,
        })),
      ];
    }

    return [
      {
        id: tagOrGroup.id,
        label: tagOrGroup.name,
      },
    ];
  });
}
